export enum FeatureState {
  enabled = 'enabled',
  disabled = 'disabled',
}
